/* src/app/components/manage-taxonomies-modal/manage-taxonomies-modal.component.scss */
.modal-header {
  margin: 0;
  padding-bottom: 0;
}
.modal-header .modal-header-content {
  padding-bottom: 1rem;
}
.key-sets-wrapper {
  width: 100%;
}
.key-sets-wrapper .tabs-wrapper {
  width: 100%;
  padding-top: 0.9375rem;
  overflow-x: auto;
  border-bottom: 1px solid rgba(46, 46, 56, 0.08);
  margin-bottom: 1rem;
  flex-wrap: nowrap;
}
.key-sets-wrapper .tabs-wrapper .tabs-container {
  margin-right: 1.5625rem;
}
.key-sets-wrapper .tabs-wrapper .tabs-container .single-tab {
  font-size: 0.875rem;
  line-height: 1.25rem;
  font-weight: 300;
  color: rgba(46, 46, 56, 0.64);
  margin-right: 1.5rem;
  border-radius: 0;
  border: 0;
  padding: 0;
  border-bottom: 0.25rem solid transparent;
  padding-bottom: 0.25rem;
  white-space: nowrap;
}
.key-sets-wrapper .tabs-wrapper .tabs-container .single-tab.active {
  color: #2e2e38;
  text-shadow: 0 0 0.1px #2e2e38, 0 0 0.1px #2e2e38;
}
.key-sets-wrapper .tabs-wrapper .tabs-container .single-tab:last-child {
  margin-right: 0;
}
.key-sets-wrapper .tabs-wrapper .tabs-container .single-tab.btn:focus {
  box-shadow: none;
}
/*# sourceMappingURL=manage-taxonomies-modal.component.css.map */
